// extracted by mini-css-extract-plugin
export default {"page-layout":"styles_page-layout__SAnh8","logo":"styles_logo__8iQip","title":"styles_title__mzm+Q","background-squares":"styles_background-squares__Pj8Hz"};